import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class StoreEventsService {

  storeChecked = new Subject<any>()

  constructor() { }
}
